/**
 * @generated SignedSource<<38c573559469cadb0b4446c5a9a36e10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type avatarRelay_UsePictureAndAppTypeFragment$data = {
  readonly appType?: string | null | undefined;
  readonly picture: AGG$URL;
  readonly " $fragmentType": "avatarRelay_UsePictureAndAppTypeFragment";
};
export type avatarRelay_UsePictureAndAppTypeFragment$key = {
  readonly " $data"?: avatarRelay_UsePictureAndAppTypeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"avatarRelay_UsePictureAndAppTypeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "avatarRelay_UsePictureAndAppTypeFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "picture"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appType"
        }
      ],
      "type": "AppUser"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "865b09ca369f75c658decd19239f2068";

export default node;
